<template>
	<div class="header">
		<div class="container-title">
			<div class="title-content">
				<div class="title">{{ title }}</div>

				<span class="subtitle">
					{{ subtitle }}
				</span>
			</div>

			<div class="enterprises-integration">
				<div :class="[{'active-integration': this.title === 'Integrações'}]" class="integration">
					<router-link to="/marketing/integracoes/erp/integracoes"
						class="content-integration">
						Integrações
					</router-link>
				</div>

				<div v-if="availabilityEnabled"
					:class="[{'active-enterprises': this.title === 'Empreendimentos'}]" class="enterprises">
					<router-link to="/marketing/integracoes/erp/empreendimentos"
						class="content-enterprises">
						Empreendimentos
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex'

	export default {
		name: 'header-integration-erp',

		props: {
			integrationsErps: {
				type: String,
			},
			title: {
				type: String,
			},
			subtitle: {
				type: String,
			},
		},

		computed: {
			...mapGetters('ERP', {
				availabilityEnabled: 'getAvailabilityEnabled'
			}),
		}
	}
</script>

<style lang='stylus' scoped>
	@import './styles.styl'
</style>